import { AppBar, Box, Button, Toolbar } from "@mui/material";
import PropTypes from "prop-types";
import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

function PublicLayout(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Box>
      <AppBar position="fixed" sx={{ width: "100%" }}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 2rem",
            '&.MuiToolbar-root': {
              backgroundColor: (localStorage.getItem("themeLightPalette") || localStorage.getItem("themeDarkPalette")) ?
                theme.palette.custom.backgroundColor : "#0f0f0f !important"
            }
          }}
        >
          <img
            style={{ width: "200px", marginRight: "4px" }}
            src={`${window.env.REACT_APP_PUBLIC_URL}/logo-text-dark.png`}
            alt="logo"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => startTransition(() => navigate("/login"))}
          >
            Login
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ mt: "4rem" }}>{props.children}</Box>
    </Box>
  );
}
PublicLayout.propTypes = {
  children: PropTypes.element,
};

export default PublicLayout;
